import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { NumberFormatProvider } from "./context/NumberFormatContext";
import { ClickstreamProvider, RouteTracker } from "./context/ClickstreamContext";
import { Toaster } from "./components/ui/sonner";

// Layout
import DashboardLayout from "./components/layout/DashboardLayout";

// Pages
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import AOPPage from "./pages/AOPPage";
import ActualsPage from "./pages/ActualsPage";
import VariancePage from "./pages/VariancePage";
import ChannelsPage from "./pages/ChannelsPage";
import HealthPage from "./pages/HealthPage";
import SimulatorPage from "./pages/SimulatorPage";
import WorkingCapitalPage from "./pages/WorkingCapitalPage";
import SettingsPage from "./pages/SettingsPage";
import CategoryMappingPage from "./pages/CategoryMappingPage";

function App() {
  return (
    <NumberFormatProvider>
    <AuthProvider>
      <BrowserRouter>
        <ClickstreamProvider>
          <RouteTracker />
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />

            {/* Protected routes */}
            <Route element={<DashboardLayout />}>
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/aop" element={<AOPPage />} />
              <Route path="/actuals" element={<ActualsPage />} />
              <Route path="/variance" element={<VariancePage />} />
              <Route path="/channels" element={<ChannelsPage />} />
              <Route path="/health" element={<HealthPage />} />
              <Route path="/simulator" element={<SimulatorPage />} />
              <Route path="/working-capital" element={<WorkingCapitalPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/category-mapping" element={<CategoryMappingPage />} />
            </Route>

            {/* Redirects */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </ClickstreamProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
    </NumberFormatProvider>
  );
}

export default App;
